
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const FilterIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M13.7252 23.5299C9.86525 18.9826 13.0972 12 19.0618 12H76.9381C82.9028 12 86.1347 18.9826 82.2748 23.5299L59 50.9495V76.9469C59 83.3451 51.1244 86.3899 46.8204 81.6556L38.8204 72.8556C37.6491 71.5671 37 69.8882 37 68.1469V50.9496L13.7252 23.5299ZM76.9381 19H19.0618L43.1683 47.3995C43.7053 48.032 44 48.8347 44 49.6644V68.1469L52 76.9469V49.6643C52 48.8346 52.2948 48.0319 52.8317 47.3994L76.9381 19Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M55.5001 49.6643V76.9469C55.5001 80.146 51.5623 81.6684 49.4103 79.3012L41.4103 70.5012C40.8246 69.857 40.5001 69.0176 40.5001 68.1469V49.6644L16.3936 21.265C14.4636 18.9913 16.0796 15.5 19.0619 15.5H76.9382C79.9206 15.5 81.5365 18.9913 79.6066 21.265L55.5001 49.6643Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M13.7252 23.5299C9.86525 18.9826 13.0972 12 19.0618 12H76.9381C82.9028 12 86.1347 18.9826 82.2748 23.5299L59 50.9495V76.9469C59 83.3451 51.1244 86.3899 46.8204 81.6556L38.8204 72.8556C37.6491 71.5671 37 69.8882 37 68.1469V50.9496L13.7252 23.5299ZM76.9381 19H19.0618L43.1683 47.3995C43.7053 48.032 44 48.8347 44 49.6644V68.1469L52 76.9469V49.6643C52 48.8346 52.2948 48.0319 52.8317 47.3994L76.9381 19Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M55.5001 49.6643V76.9469C55.5001 80.146 51.5623 81.6684 49.4103 79.3012L41.4103 70.5012C40.8246 69.857 40.5001 69.0176 40.5001 68.1469V49.6644L16.3936 21.265C14.4636 18.9913 16.0796 15.5 19.0619 15.5H76.9382C79.9206 15.5 81.5365 18.9913 79.6066 21.265L55.5001 49.6643Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
